import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconSize } from '../../../../../elements/components/icon/entities/icon-sizes.entity';
import { IFilterData } from '../../../entities/filter-data.entity';
import { Filter } from '../../../entities/filter.class';
import { FilterBarTranslations } from '../../entities/filter-bar-translations';
import { FilterType } from '../../entities/filter-type';
import { BaseFilterDirective } from '../base-filter/base-filter.component';
import { ShFilterDateComponent } from '../../../components/filter-date/filter-date.component';
import { ShFilterMultiSelectComponent } from '../../../components/filter-multiselect/filter-multiselect.component';
import { ShIconComponent } from '../../../../../elements/components/icon/icon.component';
import { NgIf, NgTemplateOutlet, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';

@Component({
    selector: 'sh-generic-filter-item',
    templateUrl: './filter-item.component.html',
    standalone: true,
    imports: [NgIf, NgTemplateOutlet, ShIconComponent, NgSwitch, NgSwitchCase, ShFilterMultiSelectComponent, ShFilterDateComponent, AsyncPipe]
})
export class ShGenericFilterItemComponent<T extends Filter> extends BaseFilterDirective<T> {
    public readonly FilterType: typeof FilterType = FilterType;
    public readonly IconSizes: typeof IconSize = IconSize;

    @Input() i18n?: FilterBarTranslations;

    @Output() removeFilter: EventEmitter<void> = new EventEmitter<void>();

    constructor() {
        super();
    }

    onRemoveFilter(): void {
        this.removeFilter.emit();
    }

    onFilterChange(filter: IFilterData): void {
        this.emitChange(filter);
    }
}
